module.exports = __webpack_public_path__ + "static/media/INSTRUCTIONS_FOR_ENTERING_SOLO_AND_ENSEMBLE_CONTEST_1_6_23.3f30873a.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/2024/INSTRUCTIONS_FOR_ENTERING_SOLO_AND_ENSEMBLE_CONTEST_1_6_23.pdf
// module id = 216
// module chunks = 0